<template>
  <DBox
    :id="'cmp-accounting-accounting_sidewindow-invoice-lines'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_invoice_line_string')}`"
    @add_click="onAddInvoiceLine"
  >
    <!-- <div class="ut-fc"> -->
    <NTable
      class="invcoie-line-list dbox1"
      :headers="headers"
      :items="selectedInvoice.invoicelines"
      :id="'accounting-invoices-invoice_line'"
      :config="tableConfig"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr @click="onInvoiceLineClicked(item)">
          <td v-bind="tdcon('qty')">
            <TextField2
              class="dbox1"
              id="qty"
              :showLabel="false"
              :disabled="selectedInvoice.disabled"
              :value="item['qty']"
              :type="'number'"
              :bb="'0px'"
              @change="(e) => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('article_ref')">
            <TextField2
              type="text"
              :showLabel="false"
              name="booking_type"
              id="booking_type"
              :disabled="selectedInvoice.disabled"
              :value="item['booking_type']"
              :bb="'0px'"
              @change="(e) => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('description')">
            <TextField2
              type="text"
              :showLabel="false"
              id="text"
              :disabled="selectedInvoice.disabled"
              :value="item['text']"
              :bb="'0px'"
              @blur="(e) => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('price')">
            <TextField2
              id="price"
              class="dbox1"
              :showLabel="false"
              :disabled="selectedInvoice.disabled"
              :value="item['price']"
              :type="'number'"
              :bb="'0px'"
              :ta="'right'"
              @change="(e) => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('amount')">
            <span style="font-weight: 700; text-align: right"
              >{{ getInvoicelineAmount(item) }}
              {{
                selectedInvoice &&
                selectedInvoice.invoiceCurrency &&
                selectedInvoice.invoiceCurrency.currency_iso
              }}</span
            >
          </td>
          <td v-bind="tdcon('vat_amount')">
            <Dropdown2
              class="dbox1 vat_amount"
              :ta="'right'"
              :showLabel="false"
              :disabled="selectedInvoice.disabled"
              :options="vatRatesTV"
              :selected="vatRatesTV.find((v) => v.value == item.vat_type)"
              :placeholder="$t('vat_type')"
              v-on:selectedChange="(e) => onVatTypechange(item, e)"
              :bb="'0px'"
              lw="105px"
            >
            </Dropdown2>
          </td>
          <td v-bind="tdcon('options')">
            <div style="padding-left: 2px" class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="(e) => onDeleteInvoiceLine(item)"
                :alt="$t('delete_invoice_line')"
                :title="$t('delete_invoice_line')"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
    <!-- <div>
        <button
          style="margin-left: 10px; margin-top: 10px"
          class="dt-button v3 c5"
          @click="onAddInvoiceLine"
        >
          + Add Invoice Row
        </button>
      </div> -->
    <!-- </div> -->
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";

import { EventHooks } from "../../../../plugins/text-field";
import { createNTableConfig } from "../../../../plugins/datatable";
import { mapGetters } from "vuex";
import { parseNumber } from "../../../../utility";
import { tv } from "../../../../models/text-value.model";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { createTableHeader } from "../../../../plugins/datatable";
export default {
  components: {
    NTable,
    DBox,
  },
  props: {
    selectedInvoice: {
      required: true,
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },

      tableConfig: createNTableConfig({
        fullHeight: true,
        headerStyle: 3,
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("qty", { f: 0.65 }),
        createTableHeader("article_ref"),
        createTableHeader("description", { f: 2.5 }),
        createTableHeader("price", { ta: "right" }),
        createTableHeader("amount", { ta: "right" }),
        createTableHeader("vat_amount", { ta: "right", minw:80,f: 0.55 , text:this.$t('vat') }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },

    vat_handling: function () {
      return this.selectedInvoice.invoice.vat_handling;
    },
    invoice: function () {
      return this.selectedInvoice?.invoice;
    },
    vatRatesTV: function () {
      return this.selectedInvoice.vatRatesTV;
    },
  },
  methods: {
    getInvoicelineAmount: function (invoiceline) {
      // return CURRENCY(parseNumber(invoiceline.qty, 1) * parseNumber(invoiceline.price, 0));
      return this.$dft.curr(
        parseNumber(invoiceline.qty, 1) * parseNumber(invoiceline.price, 0),
        this.selectedInvoice.invoiceCurrency.currency_iso
      );
    },

    onInvoiceLineClicked: function (item) {},
    onVatTypechange: function (item, value) {
      this.$emit("changed", {
        name: "vat_type",
        value: value.value,
        item,
      });
    },
    // onInvoiceTextFieldValueChange: function (name, value) {
    //   // console.log({name, value});
    //   this.$emit("invoice_change", { name, value });
    // },
    onRadioChange: function (event) {
      const value = event.target.value;
      this.$emit("change_tax_deduc", { name: "vat_handling", value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("change_tax_deduc", {
        name: "tax_type_id_deduction",
        value: value.value,
      });
    },
    onAddInvoiceLine: function () {
      this.$emit("invoiceline_added", true);
    },
    onDeleteInvoiceLine: async function (item) {
      const confirmationResult = await confirmDelete("Invoice Line");
      if (confirmationResult === "OK") {
        this.$emit("invoiceline_deleted", item);
      }
    },
    onTextFieldChange: function ({ name, value }, item) {
      if (name == "price") {
        value = (+value).toFixed(2);
      }
      // This Line Causing the Data not being Updated in the server Bug -- NEED DISCUSSION
      // item[name] = value;
      this.$emit("changed", {
        name,
        value,
        item,
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-accounting-accounting_sidewindow-invoice-lines {
  .vat_amount {
    .dropdown--main__text {
      text-align: right;
      justify-content: flex-end;
      padding-right: 5px;
    }
  }
  .menu__content {
    .dropdown--list {
      min-width: 135px !important;
    }
    .dropdown--item {
      justify-content: flex-end !important;
    }
  }
}
</style>
